import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import { ClearDetailsImport, DetailsImport, DetailsImportError, MatchingColumns, MatchingColumnsSuccess } from '../../store/imports.actions';
import { Observable, Subscription, tap } from 'rxjs';
import { IExecuteSeccess, IMatchingColumn } from '../../models/imports.models';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'app-details-imports',
  templateUrl: './details-imports.component.html',
  styleUrls: ['./details-imports.component.scss']
})
export class DetailsImportsComponent implements OnInit {
  importId!: number;
  detailsImport$: Observable<IExecuteSeccess | null> = this.store.select((state)=> state.importProducts.deatailsImport);
  subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.importId = +this.route.snapshot.paramMap.get('id')!;
    if (this.importId) {
      this.store.dispatch(SetCurrentElementId({ currentElementId: this.importId }))
      this.store.dispatch(DetailsImport({ id: this.importId }))
    }

    const sub1 = this.actions$.pipe(
      ofType(DetailsImportError),
      tap(() => {
        this.router.navigate(['imports']);
      })
    ).subscribe();

    const sub2 = this.actions$.pipe(
      ofType(MatchingColumnsSuccess),
      tap(() => {
        this.router.navigate(['imports']);
      })
    ).subscribe();

    this.subscriptions.push(sub1, sub2);
  }

  getFieldIndex(fields: string[], columns: string[], fieldName: string): string {    
    const index = fields.indexOf(fieldName);
    return index !== -1 ? columns[index] : '';
  }

  commit(detailsImport: IExecuteSeccess) {
    const data: IMatchingColumn = {
      test: false,
      columns: detailsImport.matches.columns,
      fields: detailsImport.matches.fields,
      sheet: detailsImport.preview.sheet,
      sheets: detailsImport.preview.sheets,
      name_create_enabled_fields: detailsImport.name_create_enabled_fields
    };
    this.store.dispatch(MatchingColumns({ id: detailsImport.id, matchingColumns: data, committed: true }));
};

  back(){
    this.router.navigate(['imports'], {
      queryParamsHandling: 'merge',
    })
  }

  ngOnDestroy() {
    this.store.dispatch(ClearDetailsImport())
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }

}
